import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Navbar = ({ darkBg, classOption }) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);

  useEffect(() => {
    const stickyheader = document.querySelector(".header");
    setHeaderTop(stickyheader.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  return (
    <>
      <header className={`header ${classOption}`}>
        <nav
          className={`navbar navbar-expand-lg fixed-top ${darkBg ? "bg-transparent" : "custom-nav white-bg"
            } ${scroll > headerTop ? "affix" : ""}`}
        >
          <div className="container">
            <Link to="/" className="navbar-brand">
              {darkBg ? (
                <img
                  src="assets/img/logo-white-1x.png"
                  width="150"
                  alt="logo"
                  className="img-fluid"
                />
              ) : (
                <img
                  src="assets/img/logo-color-1x.png"
                  width="120"
                  alt="logo"
                  className="img-fluid"
                />
              )}
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="ti-menu"></span>
            </button>
            <div
              className="collapse navbar-collapse main-menu"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto">

                <li className="nav-item">
                  <HashLink className="nav-link" smooth to="/">
                    Home
                  </HashLink>
                </li>
                {/* MENU PRIMARIOS */}
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link  dropdown-toggle"
                    to="/"
                    id="navbarPrimariosPage"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Primarios
                  </Link>

                  <div
                    className="dropdown-menu submenu"
                    aria-labelledby="navbarPrimariosPage"
                  >
                    <Link className="dropdown-item" to="/villa-carlos-paz">
                      Villa Carlos Paz
                    </Link>
                    <Link className="dropdown-item" to="/san-pedro">
                      San Pedro
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="/ramallo"
                    >
                      Ramallo
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="/costa-atlantica-primarios"
                    >
                      Costa Atlántica
                    </Link>
                  </div>
                </li>
                {/* MENU SECUNDARIOS */}
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link  dropdown-toggle"
                    to="/"
                    id="navbarSecundariosPage"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Secundarios
                  </Link>

                  <div
                    className="dropdown-menu submenu"
                    aria-labelledby="navbarSecundariosPage"
                  >
                    <Link className="dropdown-item" to="/bariloche">
                      Bariloche
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="/villa-carlos-paz-secundarios"
                    >
                      Villa Carlos Paz
                    </Link>
                    <Link
                      className="dropdown-item"
                      to="/costa-atlantica-secundarios"
                    >
                      Costa Atlántica
                    </Link>
                    <Link className="dropdown-item" to="/brasil">
                      Brasil
                    </Link>
                  </div>
                </li>
                <li className="nav-item">
                  <HashLink
                    className="nav-link"
                    smooth
                    to="https://www.paxmanager.com.ar/upgrade/"
                    target="_blank"
                  >
                    Auto Gestion
                  </HashLink>
                </li>
                <li className="nav-item">
                  <HashLink
                    className="nav-link"
                    smooth
                    to="https://fichamedica.paxid.net/ficha/?code=upg"
                    target="_blank"
                  >
                    Ficha Medica
                  </HashLink>
                </li>

                <li className="nav-item">
                  <HashLink className="nav-link" smooth to="/contacto">
                    Contacto
                  </HashLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;
